import { useState } from 'react';
import { useThunkDispatch } from 'utils/reduxHook';
import Select from 'components/molecules/Select';
import InAppRoutes, { pushProgressive } from 'utils/router';
import Button from 'components/atoms/Button';
import { closeModal } from 'actions/modal';
import { TemplateType } from 'utils/gloo-types';
import ModalWrapper from './ModalWrapper';

const templateOptions = [
  {
    value: TemplateType.BROADCAST,
    label: 'Broadcast',
  },
  {
    value: TemplateType.DOWNLOAD,
    label: 'Download',
  },
  {
    value: TemplateType.KEYWORD,
    label: 'Keyword',
  },
  {
    value: TemplateType.LINK,
    label: 'Link',
  },
  {
    value: TemplateType.SERIES,
    label: 'Series',
  },
  {
    value: TemplateType.SURVEY,
    label: 'Survey',
  },
  {
    value: TemplateType.SCHOLARSHIP,
    label: 'Scholarship',
  },
  {
    value: TemplateType.VIDEO,
    label: 'Video',
  },
];

function ThryveAdminNewTemplateType() {
  const dispatch = useThunkDispatch();
  const [selectedType, setSelectedType] = useState(null);

  const handleTemplateTypeSelect = () => {
    pushProgressive(InAppRoutes.getString(InAppRoutes.AdminTemplateCreate, selectedType.value));
    dispatch(closeModal());
  };

  const options = [...templateOptions].filter(Boolean);

  return (
    <ModalWrapper>
      <Select
        dataDurableId="thryveAdminNewTemplateSelectId"
        className="mb-4"
        label="Choose a new Resource Type"
        options={options}
        placeholder="- TYPE -"
        onChange={setSelectedType}
      />
      <Button type="primary" onClick={handleTemplateTypeSelect} dataDurableId="createNewTemplateButton">
        Create New Template
      </Button>
    </ModalWrapper>
  );
}

export default ThryveAdminNewTemplateType;
